export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'veltrix_token',
  REFRESH_TOKEN: 'veltrix_refresh_token',
  ADMIN_REFRESH_TOKEN: 'veltrix_admin_refresh_token',
  USER: 'veltrix_user',
  ADMIN_TOKEN: 'veltrix_admin_token',
  ADMIN_USER: 'veltrix_admin_user',
  BRANDING: 'veltrix_branding',
  LOCALE: 'veltrix_locale',
  USER_LOCALE: 'veltrix_user_locale',
  SYSTEM_LOCALE: 'veltrix_system_locale',
  PWA_INSTALLED: 'veltrix_pwa_installed',
  NOTIFICATIONS: 'veltrix_notifications',
  SESSION_META: 'veltrix_session_meta',
}

const LEGACY_TO_VELTRIX = {
  dragoncore_token: STORAGE_KEYS.ACCESS_TOKEN,
  dragoncore_refresh_token: STORAGE_KEYS.REFRESH_TOKEN,
  dragoncore_admin_refresh_token: STORAGE_KEYS.ADMIN_REFRESH_TOKEN,
  dragoncore_user: STORAGE_KEYS.USER,
  dragoncore_admin_token: STORAGE_KEYS.ADMIN_TOKEN,
  dragoncore_admin_user: STORAGE_KEYS.ADMIN_USER,
  dragoncore_branding: STORAGE_KEYS.BRANDING,
  dragoncore_locale: STORAGE_KEYS.LOCALE,
  dragoncore_user_locale: STORAGE_KEYS.USER_LOCALE,
  dragoncore_system_locale: STORAGE_KEYS.SYSTEM_LOCALE,
  dragoncore_pwa_installed: STORAGE_KEYS.PWA_INSTALLED,
  dragoncore_notifications: STORAGE_KEYS.NOTIFICATIONS,
  dragonpanel_admin_sse_last_id: 'veltrix_admin_sse_last_id',
  dragonpanel_dismissed_sync_jobs: 'veltrix_dismissed_sync_jobs',
}

export function migrateLegacyStorageKeys() {
  if (typeof window === 'undefined') {
    return
  }

  const storages = []
  try {
    storages.push(localStorage)
  } catch {
    /* ignore */
  }
  try {
    storages.push(sessionStorage)
  } catch {
    /* ignore */
  }

  for (const storage of storages) {
    for (const [legacyKey, veltrixKey] of Object.entries(LEGACY_TO_VELTRIX)) {
      const legacyValue = storage.getItem(legacyKey)
      if (legacyValue === null) {
        continue
      }

      if (storage.getItem(veltrixKey) === null) {
        storage.setItem(veltrixKey, legacyValue)
      }

      storage.removeItem(legacyKey)
    }
  }
}
